import type { EnemyFaction } from "./entity.js";

/**
 * HUD and sprite colour per faction — single source of truth so the
 * `EnemyMeter` border, the procedural sprite rim, and any future target
 * reticle all agree.
 *
 * Spec: `specs/enemies-and-ai.md` — hostile→red, neutral→yellow,
 * friendly→blue. The party is not a faction in this system; party bars
 * use green elsewhere in the HUD.
 */
export const FACTION_COLORS: Readonly<Record<EnemyFaction, string>> = {
  hostile: "#ff4444",
  neutral: "#ffcc00",
  friendly: "#4a9eff",
};

export function factionColor(faction: EnemyFaction): string {
  return FACTION_COLORS[faction];
}

/**
 * Muted variants for the in-world sprite rim. The bright HUD colors
 * above read as garish neon outlines when stamped around dungeon-lit
 * sprite art, so the rim uses these darker shades (and partial opacity
 * at the compositing site) while HUD chrome keeps the saturated set.
 */
export const FACTION_RIM_COLORS: Readonly<Record<EnemyFaction, string>> = {
  hostile: "#8a2020",
  neutral: "#8a6a1f",
  friendly: "#1f4d8a",
};

export function factionRimColor(faction: EnemyFaction): string {
  return FACTION_RIM_COLORS[faction];
}
